export enum PermissionTypes {
  project = "Project",
  team = "Team"
}

export enum PermissionActions {
  add = "add",
  delete = "delete",
  remove = "remove"
}
